import { useContext } from 'react'
import { BackgroundImageContext } from '~/components/DrawingCanvas/BackgroundImage/components/BackgroundImageProvider'

export const useBackgroundImage = () => {
  const value = useContext(BackgroundImageContext)
  if (!value) throw new Error('Must call useBackgroundImage within context')
  return value
}
